<template>
<div>
	<Card title="投保公司">
    	<Form :label-width="150" class="mt15">
			<Row>
        		<Col span="12">
					<FormItem label="公司名称：">
						{{info.applicantName}}
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="证件号：">
						<span class="lineFeed">{{applicantList.idNumber}}</span>
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="社会统一信用代码：">
						<span class="lineFeed">{{applicantList.idNumber}}</span>
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="联系人姓名：">
						{{applicantList.contactName}}
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="联系人电话：">
						{{applicantList.contactPhone}}
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="联系人邮箱：">
						{{applicantList.contactEmail}}
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="企业地址：">
						{{applicantList.address}}
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="营业执照：">
						<a :href="applicantList.bizUrl" target="_blank" class="ml15">查看</a>
					</FormItem>
				</Col>
			</Row>
		</Form>
    </Card>
  </div>
</template>
<script>
export default {
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
		type:{
			type:String,
			default(){
				return ''
			}
		},
	},
	data(){
		return {
		}
	},
	computed:{
		applicantList(){
			return (this.info.applicantList&&this.info.applicantList.length>0)?this.info.applicantList[0]: {}
		}
	},
	methods:{
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/common/insuranceCompany.vue